<template>
  <div class="my_rich_text m-lr-11">
    <span class="title" :style="`flex: 0 0 ${!Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth}`">{{ title }}</span>
    <div class="text_box">
      <div class="text_content">{{ resultText }}</div>
      <div class="jz_edit_box_btn" @click="show_dialog">
        <i class="el-icon-edit-outline"></i>
        <span>{{$t('components_basic_addarticle_index_2003')}}</span>
      </div>
    </div>
    <my_rich_dialog :item="item" :max-len="maxLen" :rich-title="richTitle" :visible.sync="richVisible" v-if="richVisible" :richText.sync="resultRichText"></my_rich_dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_rich_text',
  props: {
    title: {
      type: String,
      default: i18n.t('components_my_rich_text_index_2424')
    },
    titleWidth: { // 组件的标题
      type: String,
      default: '40'
    },
    richText: {
      type: String,
      defalut: ''
    },
    richTitle: {
      type: String,
      defalut: i18n.t('components_my_rich_text_index_2425')
    },
    maxLen: {
      type: Number,
      default: 10000,
    },
    item: {
      type: Array,
      default : () =>["source",
        "selectall",
        "plainpaste",
        "undo",
        "redo",
        "formatblock",
        "fontname",
        "fontsize",
        "forecolor",
        "hilitecolor",
        "bold",
        "underline",
        "italic",
        "subscript",
        "superscript",
        "align",
        "lineheight",
        "indent",
        "outdent",
        "insertorderedlist",
        "insertunorderedlist",
        "image",
        "link",
        "unlink",
        "media",
        "table",
        "hr",
        "pagebreak",
        "clearhtml",
      ]
    }
  },
  watch: {
    resultRichText (val) {
      this.resultText = val.split(/<\/?\w+[^>]*>/g).filter(Boolean).join()
      this.$emit('update:richText', val)  // 双向数据绑定
    },
    richText (val) {
      this.resultRichText = val
    },
  },
  data () {
    return {
      richVisible: false,
      resultRichText: this.richText,
      resultText: this.richText.split(/<\/?\w+[^>]*>/g).filter(Boolean).join()
    }
  },
  methods: {
    show_dialog () {
      this.richVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.my_rich_text {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: top;
  margin-bottom: 8px;
  .title {
    display: inline-block;
    font-size: 13px;
    text-align: right;
    overflow: hidden;
    height: 32px;
    line-height: 32px;
  }
  .text_box {
    position: relative;
    flex: 1;
    margin-left: 10px;
    height: 74px;
    border: 1px dashed #ccc;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    &:hover {
      border-color: #6d83d6;
    }
    .text_content {
      max-width: 250px;
      width: 100%;
      height: 100%;
      overflow: hidden;
      word-break: auto-phrase;
    }
    .jz_edit_box_btn {
      position: absolute;
      right: 0;
      bottom: 0;
      // width: 60px;
      width: auto;
      padding: 0 6px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: rgba(0, 120, 215, 0.9);
      cursor: pointer;
      i {
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_rich_text/index.vue